import { InjectionToken } from '@angular/core';
import { Utils } from '@shared/abstraction/utils/utils';

export const GLOBAL_UTILS = new InjectionToken<Utils>('GLOBAL_UTILS');
